// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#illustration {
  width: 90%;
  height: auto;
  margin: 0 auto;
  display: block;
}

.st0 {
  opacity: 0.1;
  enable-background: new;
}

.st1 {
  fill: url(#SVGID_1_);
}

.st3 {
  fill: #FFFFFF;
}

.st4 {
  fill: url(#SVGID_2_);
}

.title {
  font-weight: bold;
  font-size: 1.8rem;
  text-align: center;
  margin-top: 0;
  font-family: var(--font);
  font-weight: 600;
  margin-bottom: 10px;
}

.body {
  font-size: 20px;
  text-align: center;
  font-family: var(--font);
  font-weight: 600;
  padding: 0 15px;
}

.qr-infos {
  text-align: center;
}

.numbers {
  font-size: 1.35em;
  font-weight: 800;
}

.counter-container {
  display: flex;
  width: 100%;
  justify-content: space-around;
  margin-top: 2rem;
}
.counter-container .text-num {
  text-align: center;
  width: 40%;
}
.counter-container .text-num h2 {
  font-family: var(--font);
  font-weight: 300;
  font-size: 38px;
  margin: 0;
}
.counter-container .text-num span {
  font-family: var(--font);
  font-weight: 400;
  font-size: 18px;
}
.counter-container .divider {
  width: 1px;
  background: var(--text-color-2nd-login-desktop);
  opacity: 0.1;
  height: 4rem;
  margin: auto 7px;
}

.qr-code {
  width: 14rem;
  height: 14rem;
  background: var(--bg-color);
  border-radius: 50%;
  display: flex;
  margin: 40px auto;
}
.qr-code img {
  width: 120px;
  height: 120px;
  margin: auto;
}

@media screen and (min-width: 768px) {
  .counter-container .text-num h2 {
    font-size: 70px;
  }
  .counter-container .text-num span {
    font-size: 20px;
  }
  .counter-container .divider {
    height: 80px;
  }
}
.itemQR h2 {
  margin-left: 10px;
}
.itemQR ion-thumbnail {
  --size: 10%;
  --border-radius: 3px;
}

.content {
  padding-top: 15px;
  padding-bottom: 66px;
}

.btn-box {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 10px 0 15px;
  border-top: 1px solid #ECEAF3;
  background-color: #ffffff;
}

.btn-default {
  border-radius: 2px;
  width: 60%;
  min-width: 216px;
  height: 40px;
}
.btn-default span {
  text-transform: none;
  font-family: var(--font);
  font-weight: 700;
  font-size: 16px;
  margin-left: 8px;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/gamification/gamification.page.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAEA;EACI,YAAA;EACA,sBAAA;AACJ;;AAEA;EACI,oBAAA;AACJ;;AAMA;EACI,aAAA;AAHJ;;AAMA;EACI,oBAAA;AAHJ;;AAMA;EACI,iBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EAEA,eAAA;AALJ;;AAQA;EACI,kBAAA;AALJ;;AAQA;EACI,iBAAA;EACA,gBAAA;AALJ;;AAQA;EACI,aAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;AALJ;AAOI;EACI,kBAAA;EACA,UAAA;AALR;AAOQ;EACI,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AALZ;AAQQ;EACI,wBAAA;EACA,gBAAA;EACA,eAAA;AANZ;AAUI;EACI,UAAA;EACA,+CAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AARR;;AAYA;EACI,YAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AATJ;AAWI;EACI,YAAA;EACA,aAAA;EACA,YAAA;AATR;;AAmBA;EAGY;IACI,eAAA;EAlBd;EAqBU;IACI,eAAA;EAnBd;EAuBM;IACI,YAAA;EArBV;AACF;AA0BI;EACI,iBAAA;AAxBR;AA2BI;EACI,WAAA;EACA,oBAAA;AAzBR;;AA8BA;EACI,iBAAA;EACA,oBAAA;AA3BJ;;AA8BA;EACI,eAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,oBAAA;EACA,6BAAA;EACA,yBAAA;AA3BJ;;AA8BA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AA3BJ;AA6BI;EACI,oBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA3BR","sourcesContent":["#illustration {\n    width: 90%;\n    height: auto;\n    margin: 0 auto;\n    display: block;\n}\n\n.st0 {\n    opacity: 0.1; // fill: #6C63FF;\n    enable-background: new;\n}\n\n.st1 {\n    fill: url(#SVGID_1_);\n}\n\n.st2 {\n    // fill: #4E5A86;\n}\n\n.st3 {\n    fill: #FFFFFF;\n}\n\n.st4 {\n    fill: url(#SVGID_2_);\n}\n\n.title {\n    font-weight: bold;\n    // font-size: 25px;\n    font-size: 1.8rem;\n    text-align: center;\n    margin-top: 0;\n    font-family: var(--font);\n    font-weight: 600;\n    margin-bottom: 10px;\n}\n\n.body {\n    font-size: 20px;\n    text-align: center;\n    font-family: var(--font);\n    font-weight: 600;\n    // margin-top: 0;\n    padding: 0 15px;\n}\n\n.qr-infos {\n    text-align: center;\n}\n\n.numbers {\n    font-size: 1.35em;\n    font-weight: 800;\n}\n\n.counter-container {\n    display: flex;\n    width: 100%;\n    justify-content: space-around;\n    margin-top: 2rem;\n\n    .text-num {\n        text-align: center;\n        width: 40%;\n\n        h2 {\n            font-family: var(--font);\n            font-weight: 300;\n            font-size: 38px;\n            margin: 0;\n        }\n\n        span {\n            font-family: var(--font);\n            font-weight: 400;\n            font-size: 18px;\n        }\n    }\n\n    .divider {\n        width: 1px;\n        background: var(--text-color-2nd-login-desktop);\n        opacity: 0.1;\n        height: 4rem;\n        margin: auto 7px;\n    }\n}\n\n.qr-code {\n    width: 14rem;\n    height: 14rem;\n    background: var(--bg-color);\n    border-radius: 50%;\n    display: flex;\n    margin: 40px auto;\n\n    img {\n        width: 120px;\n        height: 120px;\n        margin: auto;\n    }\n}\n\n// .background {\n//     max-height: calc(100vh - 56px) !important;\n//     // position: relative;\n//     // padding-top: 15px;\n// }\n\n@media screen and (min-width: 768px) {\n    .counter-container {\n        .text-num {\n            h2 {\n                font-size: 70px;\n            }\n\n            span {\n                font-size: 20px;\n            }\n        }\n\n        .divider {\n            height: 80px;\n        }\n    }\n}\n\n.itemQR {\n    h2 {\n        margin-left: 10px;\n    }\n\n    ion-thumbnail {\n        --size: 10%;\n        --border-radius: 3px;\n\n    }\n}\n\n.content {\n    padding-top: 15px;\n    padding-bottom: 66px;\n}\n\n.btn-box {\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    padding: 10px 0 15px;\n    border-top: 1px solid #ECEAF3;\n    background-color: #ffffff;\n}\n\n.btn-default {\n    border-radius: 2px;\n    width: 60%;\n    min-width: 216px;\n    height: 40px;\n\n    span {\n        text-transform: none;\n        font-family: var(--font);\n        font-weight: 700;\n        font-size: 16px;\n        margin-left: 8px;\n        color: #fff;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
